export default "__VITE_ASSET__C35xYZjd__"